<template>
	<div
		class="button-container"
		:class="{ 'button-container--full-width': fullWidth }"
		@click="$emit('click', $event)"
	>
		<div class="button-container__promo-wrapper">
			<button
				class="offer__cta"
				:class="{
					'offer__cta--yellow': !isHighlighted,
					'is-highlighted-row': isHighlighted,
				}"
			>
				<FontAwesomeIcon :icon="faPlay" size="lg" class="play-icon" />

				<span class="offer__cta__text">
					<slot>
						{{ isHighlighted ? $t('WEBAPP_STREAM_FREE') : $t('WEBAPP_STREAM_FOR_FREE') }}
					</slot>
				</span>
			</button>
		</div>

		<div class="offer__detail" v-show="hasPromotionTag">
			<p>{{ $t('WEBAPP_PROMOTED') }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { faPlay } from '@fortawesome/free-solid-svg-icons';

defineProps<{
	isHighlighted?: boolean;
	hasPromotionTag?: boolean;
	fullWidth?: boolean;
}>();
</script>

<style scoped lang="scss">
.button-container {
	display: flex;
	align-items: flex-end;
	flex-direction: column;
	max-width: inherit;
	min-width: 170px;
	flex-shrink: 0;

	@media (max-width: 1100px) {
		min-width: 150px;
	}

	&__promo-wrapper {
		display: flex;
		flex-direction: column;
		border-radius: 8px;
		min-width: 166px;

		@media (max-width: 1100px) {
			min-width: 110px;
		}

		@media (max-width: 1050px) {
			min-width: 166px;
		}
		&__promo {
			color: #f20000;
			height: 40px;
			border-radius: 8px;
			font-size: 16px;
			font-weight: 900;
			letter-spacing: 0.24px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.offer__cta {
		height: 40px;
		width: fit-content;
		min-width: 166px;
		padding: 8px 16px;
		border-radius: 8px;
		border: none;
		background: #303740;
		color: var(--jw-grey-200);
		font-size: 16px;
		font-weight: 900;
		letter-spacing: 0.24px;
		cursor: pointer;

		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		&:hover {
			background: #303740cb;
		}

		@media (max-width: 1100px) {
			min-width: 110px;
		}

		@media (max-width: 1050px) {
			min-width: 166px;
		}

		@media (max-width: 1024px) {
			width: fit-content;
			padding: 0 16px;
			flex: 0 1 auto;
			margin-inline-start: 0;
		}

		&--yellow {
			background: var(--jw-yellow-500);
			color: var(--jw-shade-black);

			&:hover {
				background: #fbc500b1;
			}
		}

		.play-icon {
			margin-inline-end: 8px;
		}

		&__text {
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}

	.offer__detail {
		padding-top: 12px;

		p {
			margin: 0;
			color: #6f7d90;
			font-size: 14px;
			line-height: 16px;
			letter-spacing: 0.21px;
		}
	}

	.is-highlighted-row {
		margin-top: 0;
	}

	&--full-width {
		width: 100%;
		.button-container__promo-wrapper {
			width: 100%;
		}
		.offer__cta {
			width: 100%;
		}
	}
}
</style>
